import { ModalFooter, ModalFooterButton } from '@/components/Modal'
import { useController } from '../hooks/useController'

import { useTexts } from '../useTexts'
import { useDeleteSimulations } from '../hooks/useDeleteSimulations'

export function Footer() {
  const texts = useTexts()
  const { status, close } = useController()
  const [submitting, deleteSimulation] = useDeleteSimulations()

  return (
    <ModalFooter
      primaryAction={
        <ModalFooterButton
          disabled={status !== 'ready'}
          loading={submitting}
          onClick={deleteSimulation}
          variant="contained"
          color="error"
          testid="delete-modal-confirm-button"
        >
          {texts.confirmButtonTitle}
        </ModalFooterButton>
      }
      secondaryAction={
        <ModalFooterButton onClick={close} testid="delete-modal-cancel-button">
          {texts.cancelButtonTitle}
        </ModalFooterButton>
      }
    />
  )
}
